"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canDeveloperDeleteGameBuild = canDeveloperDeleteGameBuild;
function canDeveloperDeleteGameBuild(gameBuildStatus) {
    return gameBuildStatus === 'DRAFT';
}
